export const SET_DEVICE_EVENT = 'set-device'
export const DEVICES_LOADED_EVENT = 'new-devices-loaded'
